import styled from '@emotion/styled'
import { Button, Card } from 'react-bootstrap'
import theme from '../../constants/theme'
import PrimaryButton from '../buttons/PrimaryButton'

export const CardBody = styled(Card.Body)({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
})

export const SelectedTimeContainer = styled.div((props) => ({
  width: '50%',
  padding: '0.75rem 1rem',
  backgroundColor: props.theme?.neutralLight || '#f8f9fa',
  borderRadius: '0.5rem',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: '1rem',
}))

export const TimeInfo = styled.div((props) => ({
  display: 'flex',
  alignItems: 'center',
  color: props.theme?.neutralDark || '#495057',
  fontWeight: 600,
}))

export const IconWrapper = styled.span({
  display: 'inline-flex',
  alignItems: 'center',
  margin: '0 0.5rem',
})

export const TimeButtonsContainer = styled.div({
  width: '50%',
  padding: '4px',
})

export const TimeButton = styled(PrimaryButton)({
  width: '100%',
  padding: '0.25rem 0.5rem',
  fontSize: '12px',
})

export const ActionsContainer = styled.div({
  width: '50%',
  margin: '0 auto',
})

export const ActionButton = styled(PrimaryButton)({
  whiteSpace: 'nowrap',
})

export const ModalOverlay = styled.div({
  position: 'fixed',
  inset: 0,
  zIndex: 50,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '1rem',
})

export const ModalBackdrop = styled.div({
  position: 'absolute',
  inset: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  zIndex: '100',
})

export const ModalContent = styled.div({
  backgroundColor: 'white',
  borderRadius: '0.5rem',
  boxShadow:
    '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  width: '100%',
  maxWidth: '42rem',
  height: '80vh',
  display: 'flex',
  flexDirection: 'column',
  zIndex: 9999,
})

export const ModalHeader = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '1rem',
  borderBottom: '1px solid #e5e7eb',
})

export const ModalTitle = styled.h2({
  fontSize: '1.25rem',
  fontWeight: 600,
  color: '#111827',
})

export const ModalSubtitle = styled.p({
  fontSize: '12px',
  color: '#4b5563',
  marginTop: '0.25rem',
})

export const CloseButton = styled(Button)({
  backgroundColor: 'transparent',
  border: 'none',
  padding: '0.5rem',
  borderRadius: '0.5rem',
  color: '#6b7280',
  transition: 'color 0.2s, background-color 0.2s',
  '&:hover': {
    backgroundColor: '#f3f4f6 !important',
    color: '#4b5563 !important',
  },
  '&:focus': {
    backgroundColor: '#f3f4f6 !important',
    color: '#4b5563 !important',
  },
  '&:active': {
    backgroundColor: '#f3f4f6 !important',
    color: '#4b5563 !important',
  },
})

export const ModalBody = styled.div({
  flex: 1,
  overflowY: 'auto',
  padding: '1rem',
})

export const TimeSlotContainer = styled.div((props) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '0.75rem',
  borderRadius: '0.5rem',
  transition: 'background-color 0.2s',
  minWidth: '60px',
  ...(props.isAvailable
    ? {
        backgroundColor: 'white',
        border: '1px solid #e5e7eb',
        color: '#111827',
        cursor: 'pointer',
        '&:hover': { backgroundColor: '#f9fafb' },
      }
    : {
        backgroundColor: '#f9fafb',
        color: '#9ca3af',
        cursor: 'not-allowed',
      }),
}))

export const TimeIconWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

export const TimeText = styled.span({
  fontSize: '12px',
  fontWeight: 500,
  marginLeft: '0.5rem',
})

export const CalendarContainer = styled.div({
  width: '100%',
  backgroundColor: 'white',
  borderRadius: '0.5rem',
  padding: '1rem',
})

export const CalendarHeader = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '1.5rem',
})

export const MonthNavButton = styled(Button)({
  backgroundColor: 'transparent',
  border: 'none',
  color: '#4b5563',
  padding: '0.5rem',
  borderRadius: '0.5rem',
  transition: 'background-color 0.2s',
  '&:hover': {
    backgroundColor: '#f3f4f6 !important',
    color: '#4b5563 !important',
  },
  '&:focus': {
    backgroundColor: '#f3f4f6 !important',
    color: '#4b5563 !important',
  },
  '&:active': {
    backgroundColor: '#f3f4f6 !important',
    color: '#4b5563 !important',
  },
})

export const MonthTitle = styled.h2({
  fontSize: '1rem',
  fontWeight: 600,
  color: '#111827',
})

export const DaysGrid = styled.div({
  display: 'grid',
  gridTemplateColumns: 'repeat(7, 1fr)',
  marginBottom: '0.5rem',
})

export const DayHeader = styled.div({
  textAlign: 'center',
  fontWeight: 500,
  color: '#4b5563',
  fontSize: '12px',
  padding: '0.5rem',
})

export const CalendarGrid = styled.div({
  display: 'grid',
  gridTemplateColumns: 'repeat(7, 1fr)',
  gap: '0.25rem',
})

export const DayCell = styled.div({
  position: 'relative',
  padding: '0.25rem',
})

const getDayButtonStyles = (props) => {
  if (props.isSelected)
    return { backgroundColor: theme.brandColorOrange, color: 'white' }
  if (props.isAvailable && props.hasSlots)
    return { '&:hover': { backgroundColor: '#f9fafb' }, cursor: 'pointer' }
  return { backgroundColor: '#f9fafb', color: '#9ca3af', cursor: 'not-allowed' }
}

export const DayButton = styled.div((props) => ({
  height: '2.5rem',
  position: 'relative',
  textAlign: 'center',
  borderRadius: '0.5rem',
  transition: 'background-color 0.2s',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  ...getDayButtonStyles(props),
  ...(props.isToday && { fontWeight: 600 }),
}))

export const SlotIndicator = styled.div({
  position: 'absolute',
  top: '-0.375rem',
  right: '-0.375rem',
  width: '0.75rem',
  height: '0.75rem',
  borderRadius: '9999px',
  border: '2px solid white',
  backgroundColor: theme.brandColorOrange,
})

export const CalendarLegend = styled.div({
  marginTop: '1rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '1rem',
  fontSize: '12px',
})

export const LegendItem = styled.div({
  display: 'flex',
  alignItems: 'center',
})

const getLegendBoxStyles = (variant) => {
  switch (variant) {
    case 'selected':
      return { backgroundColor: theme.brandColorOrange, color: 'white' }
    case 'unavailable':
      return { backgroundColor: '#f9fafb', color: '#9ca3af' }
    case 'hasSlots':
      return { color: '#111827' }
    default:
      return {}
  }
}

export const LegendBox = styled.div((props) => ({
  width: '1.5rem !important',
  height: '1.5rem !important',
  borderRadius: '0.5rem',
  marginRight: '0.5rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '12px',
  ...getLegendBoxStyles(props.variant),
}))

export const LegendText = styled.span({
  color: '#4b5563',
})

export const SlotIndicatorWrapper = styled.div({
  position: 'relative',
  width: '1.5rem',
  height: '1.5rem',
  marginRight: '0.5rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

export const AvailableDatesSection = styled.div({
  marginTop: '2rem',
})

export const SectionHeader = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '0.5rem',
})

export const SectionTitle = styled.h3({
  fontSize: '1rem',
  fontWeight: 600,
  color: '#111827',
})

export const DateDisplay = styled.span({
  fontSize: '12px',
  color: '#4b5563',
})

export const SlotsGrid = styled.div({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '0.75rem',
  '@media (min-width: 640px)': { gridTemplateColumns: 'repeat(3, 1fr)' },
})

export const NoSlotsMessage = styled.div({
  textAlign: 'center',
  padding: '1.5rem 1rem',
  backgroundColor: '#f9fafb',
  borderRadius: '0.5rem',
})

export const NoSlotsText = styled.p({
  color: '#6b7280',
})

export const NoSlotsSubtext = styled.p({
  fontSize: '12px',
  color: '#9ca3af',
  marginTop: '0.25rem',
})

export const BookedBadge = styled.div({
  position: 'absolute',
  top: '0.25rem',
  right: '0.25rem',
  backgroundColor: '#ef4444',
  color: 'white',
  padding: '0.15rem 0.4rem',
  borderRadius: '0.3rem',
  fontSize: '10px',
  fontWeight: 'bold',
  zIndex: 1,
})
